module.exports = __webpack_public_path__ + "img/34-02.e759f8c4.png";